import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = {
  key: 0,
  style: {"width":"100%","table-layout":"auto","border-spacing":"0"}
}
const _hoisted_3 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.tableData)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", {
              style: _normalizeStyle(_ctx.thStyle)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData.headers, (header, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: index,
                  style: _normalizeStyle(_ctx.thStyle)
                }, _toDisplayString(header), 5))
              }), 128))
            ], 4)
          ]),
          _createElementVNode("tbody", {
            style: _normalizeStyle([{"text-align":"right"}, _ctx.tableTheme.rows])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData.rows, (row, rIndex) => {
              return (_openBlock(), _createElementBlock("tr", { key: rIndex }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.values, (item, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: index,
                    style: _normalizeStyle(_ctx.tdStyle(row.type, rIndex))
                  }, _toDisplayString(_ctx.formatCellValue(item)), 5))
                }), 128)),
                (_ctx.emptyColsCount(row))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 0,
                      colspan: _ctx.emptyColsCount(row),
                      style: _normalizeStyle(_ctx.tdStyle(row.type, rIndex))
                    }, null, 12, _hoisted_3))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ]))
}